/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Privacy_Data_Processing_Item_Job_DescInputs */

const en_privacy_data_processing_item_job_desc = /** @type {(inputs: Privacy_Data_Processing_Item_Job_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (` Applications submitted, job descriptions, cover letters — Legal basis: Contract performance (Art. 6(1)(b) GDPR)`)
};

const de_privacy_data_processing_item_job_desc = /** @type {(inputs: Privacy_Data_Processing_Item_Job_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (` Eingereichte Bewerbungen, Stellenbeschreibungen, Anschreiben — Rechtsgrundlage: Vertragserfuellung (Art. 6 Abs. 1 lit. b DSGVO)`)
};

const fr_privacy_data_processing_item_job_desc = /** @type {(inputs: Privacy_Data_Processing_Item_Job_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (` Candidatures soumises, descriptions de poste, lettres de motivation`)
};

const es_privacy_data_processing_item_job_desc = /** @type {(inputs: Privacy_Data_Processing_Item_Job_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (` Solicitudes enviadas, descripciones de puesto, cartas de presentación`)
};

const it_privacy_data_processing_item_job_desc = /** @type {(inputs: Privacy_Data_Processing_Item_Job_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (` Candidature inviate, descrizioni di lavoro, lettere di presentazione`)
};

const nl_privacy_data_processing_item_job_desc = /** @type {(inputs: Privacy_Data_Processing_Item_Job_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (` Ingediende sollicitaties, vacatureteksten, motivatiebrieven`)
};

const pl_privacy_data_processing_item_job_desc = /** @type {(inputs: Privacy_Data_Processing_Item_Job_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (` Wysłane aplikacje, opisy stanowisk, listy motywacyjne`)
};

const fi_privacy_data_processing_item_job_desc = /** @type {(inputs: Privacy_Data_Processing_Item_Job_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (` Lähetetyt hakemukset, työpaikkakuvaukset, saatekirjeet`)
};

const da_privacy_data_processing_item_job_desc = /** @type {(inputs: Privacy_Data_Processing_Item_Job_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (` Indsendte ansøgninger, jobbeskrivelser, ansøgningsbreve`)
};

const sv_privacy_data_processing_item_job_desc = /** @type {(inputs: Privacy_Data_Processing_Item_Job_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (` Inskickade ansökningar, jobbbeskrivningar, personliga brev`)
};

/**
* | output |
* | --- |
* | "Applications submitted, job descriptions, cover letters — Legal basis: Contract performance (Art. 6(1)(b) GDPR)" |
*
* @param {Privacy_Data_Processing_Item_Job_DescInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const privacy_data_processing_item_job_desc = /** @type {((inputs?: Privacy_Data_Processing_Item_Job_DescInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Privacy_Data_Processing_Item_Job_DescInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_privacy_data_processing_item_job_desc(inputs)
	if (locale === "fr") return fr_privacy_data_processing_item_job_desc(inputs)
	if (locale === "es") return es_privacy_data_processing_item_job_desc(inputs)
	if (locale === "it") return it_privacy_data_processing_item_job_desc(inputs)
	if (locale === "nl") return nl_privacy_data_processing_item_job_desc(inputs)
	if (locale === "pl") return pl_privacy_data_processing_item_job_desc(inputs)
	if (locale === "fi") return fi_privacy_data_processing_item_job_desc(inputs)
	if (locale === "da") return da_privacy_data_processing_item_job_desc(inputs)
	if (locale === "sv") return sv_privacy_data_processing_item_job_desc(inputs)
	return en_privacy_data_processing_item_job_desc(inputs)
});